import { useMemo, useEffect } from 'react';
import { debounce } from 'lodash';

export default function useDebouncedDispatch(delay = 500) {
    // A map to store debounced functions for each reducer action
    const debouncedDispatchers = useMemo(() => new Map(), []);

    // Function to get or create a debounced version of a dispatch function
    const getDebouncedDispatcher = (dispatchFunction: any) => {
        if (!debouncedDispatchers.has(dispatchFunction)) {
            // Create a debounced version of the dispatch function
            const debounced = debounce(dispatchFunction, delay);
            debouncedDispatchers.set(dispatchFunction, debounced);
        }
        return debouncedDispatchers.get(dispatchFunction);
    };

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            debouncedDispatchers.forEach((debounced) => debounced.cancel());
        };
    }, [debouncedDispatchers]);

    return getDebouncedDispatcher;
}

